import { ReactEnvironments } from "../pages/common/constants";
import { getENV } from "../utils";
import { loadExternalScript } from "./scriptLoader";

export const loadWalkMe = (loginId: string): void => {
  window.walkme_object = { loginId };
  const env = getENV();

  const walkMeFileToLoad =
    env === ReactEnvironments.Production
      ? "/walkme-prod.js"
      : "/walkme-non-prod.js";

  if (document.querySelector(`script[src="${walkMeFileToLoad}"]`)) return;

  loadExternalScript(walkMeFileToLoad, "walkme-script");
};
